import AuthTypes from '#libs/AuthTypes/AuthTypes.js';

export default function generatePostHeadline(fileName) {
	if (!fileName) {
		return '';
	}

	const authHeader = { Authorization: AuthTypes.getHeader() };
	const params = new URLSearchParams({ file_name: fileName }).toString();
	const url = `${window.BASE_URL}/api/v2/file_processing/open_ai/headline?${params}`;

	return fetch(url, {
		method: 'GET',
		headers: { ...authHeader },
	})
		.then(res => res.json())
		.catch(e => {
			console.log(e.message);
			return '';
		});
}
